module.exports = "/_next/static/images/e29a146860aa7e6091465dd0ce8f792d-image-right-lg.jpg.webp";